import http from 'hub-http/clients/apiClient';
const API_BASE = 'app-users/v1/users';
export default class AppUsersAPI {
  static removeFromAccount() {
    return http.delete(`${API_BASE}/self-remove`);
  }
}